import React from "react";

import PropTypes from "prop-types";

import { StarIcon } from "../../__components__/icons";

function StarRating({ rating, selectedStars, disableStars, handleStarClick }) {
    return (
        <label
            htmlFor={`star-${rating}`}
            className={`ek-chat__satisfaction--star${
                selectedStars === rating ? " selected" : ""
            }${disableStars ? " disabled" : ""}`}
            style={{
                cursor: disableStars ? "none" : "pointer",
            }}
        >
            <input
                type="radio"
                id={`star-${rating}`}
                value={rating}
                name="stars"
                onClick={() => handleStarClick(rating)}
            />
            <StarIcon />
        </label>
    );
}

StarRating.propTypes = {
    rating: PropTypes.number.isRequired,
    selectedStars: PropTypes.number,
    disableStars: PropTypes.bool,
    handleStarClick: PropTypes.func,
};

StarRating.defaultProps = {
    selectedStars: null,
    disableStars: false,
    handleStarClick: () => {},
};

export default StarRating;
